/**
 * Billing-paused banner.
 *
 * Polls GET /api/billing/status on mount; renders a yellow warning banner
 * when the backend reports the billing kill switch is on (BILLING_PAUSED=true
 * env var). Rendered inside admin billing pages so users see why action
 * buttons return 503 if the API is hit directly.
 *
 * The component is self-contained — no parent props needed. Drop in at the
 * top of any billing admin view's render tree.
 */

import React, { useEffect, useState } from 'react'
import { authenticatedFetchJson } from '../services/api/apiClient'
import { apiEndpoints } from '../consts'
import logger from '../utils/logger'
import styles from './BillingPausedBanner.module.scss'

const BillingPausedBanner = () => {
  const [paused, setPaused] = useState(false)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await authenticatedFetchJson(apiEndpoints.billingStatus)
        if (cancelled) return
        setPaused(Boolean(res?.data?.paused))
      } catch (err) {
        if (!cancelled) logger.warn('BillingPausedBanner: status fetch failed', err)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  if (!paused) return null

  return (
    <div role="status" className={styles.banner}>
      <strong>Billing operations paused.</strong> Invoice generation, approvals, finalize, reupload,
      manual emails, and Stripe webhook side-effects are temporarily disabled on this environment.
      Read-only views are still available. Contact engineering before re-enabling.
    </div>
  )
}

export default BillingPausedBanner
